import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { clientStore } from 'apps/client/app';

import TableOfContents from 'apps/readme/views/tableOfContents';
import { MarkdownBody } from 'apps/readme/views/body';

import { withConditional } from 'legacyComponents/hoc/conditional';

import { MainWrapper } from 'apps/readme/styles';
import { TabHeight } from 'legacyComponents/styled/lib';
import { ButtonGroup } from 'legacyComponents/styles';
import { Button, Loading } from 'components';
import { Section } from 'legacyComponents/layout/section';
import { NoDataCard } from 'legacyComponents/cards/types/noData';

const ConditionalButtonGroup = withConditional(ButtonGroup);

@withNamespaces()
@observer
export class Readme extends React.Component {
  render() {
    const {
      title,
      project,
      repoManager,
      insideFolder,
      last = false,
      t,
    } = this.props;
    const { readme, repository } = repoManager;
    const {
      inSpace: { whichTypes },
    } = project;
    const isOwner = whichTypes.includes('Contribution');

    if (!readme?.initialized) {
      return (
        <Section title={title} last={last}>
          <NoDataCard
            type={insideFolder ? 'folderReadme' : 'readme'}
            owner={isOwner}
            manager={repoManager}
            project={project}
          />
        </Section>
      );
    }

    const { editing, Edit, Save, Cancel, Contribute } = readme;
    if (readme.file?.readingFile) {
      return (
        <Section title={title} last={last}>
          <TabHeight>
            <Loading />
          </TabHeight>
        </Section>
      );
    }
    const { hasOpenContribution, pendingOperations } = repository;
    const contributeWarning = null;
    const isLocalChange = !!(
      hasOpenContribution &&
      pendingOperations.find(op => op.file && op.file.filename === 'README.md')
    );

    // if (isLocalChange) {
    //   const spaceType = repoManager.variables.space.startsWith('+')
    //     ? 'initiative'
    //     : 'profile';
    //   contributeWarning = (
    //     <Banner variant={'warning'}>
    //       <Trans>
    //         This Readme has local change, only visible to you. Remember to{' '}
    //         <Link
    //           name={`${spaceType}.project.files`}
    //           params={{
    //             [`${spaceType}`]: repoManager.variables.space,
    //             slug: repoManager.variables.slug,
    //           }}
    //         >
    //           contribute it from the Files tab
    //         </Link>{' '}
    //         when it&apos;s ready to go live.
    //       </Trans>
    //     </Banner>
    //   );
    // }

    // If the error.code == 404 we should probably present the user with an empty readme to create a file??
    const emptyView = readme.file?.error ? (
      <div>
        <Trans>
          Failed to download Readme file:{' '}
          <span>{readme.file.error.message}</span>
        </Trans>
      </div>
    ) : (
      <Loading isLayoutCentered />
    );

    return (
      <Section
        ref={previewer => {
          readme.previewer = previewer;
        }}
        title={this.props.title}
        subTitle={
          editing ? t('(Edit Mode)') : isLocalChange ? '(Local changes)' : ''
        }
        subTitleColor={!editing && isLocalChange ? '#ffcb00' : ''}
        last={last}
      >
        {contributeWarning}
        <MainWrapper>
          {readme.sectionApps.length === 0 ? (
            emptyView
          ) : (
            <>
              <TableOfContents readme={readme} />
              <MarkdownBody
                readme={readme}
                isOwner={isOwner}
                isLocalChange={isLocalChange}
                repository={repository}
                repoManager={repoManager}
              />
            </>
          )}
        </MainWrapper>
        <ConditionalButtonGroup
          condition={
            isOwner && !['s', 'xs'].includes(clientStore.activeBreakPoint)
          }
        >
          {editing ? (
            <>
              <Button
                text={<Trans>Cancel</Trans>}
                onClick={Cancel}
                disabled={readme.uploading}
                variant='tertiary'
                outline
              />
              <Button
                text={<Trans>Save draft</Trans>}
                onClick={Save}
                disabled={readme.uploading}
              />
            </>
          ) : (
            <>
              <Button
                text={<Trans>Edit</Trans>}
                onClick={Edit}
                disabled={readme.uploading}
                variant='tertiary'
                outline
              />
              {isLocalChange && (
                <Button
                  text={<Trans>Contribute</Trans>}
                  onClick={() => Contribute(repository)}
                  disabled={!repository.contributionReady || readme.uploading}
                  icon='check'
                />
              )}
            </>
          )}
        </ConditionalButtonGroup>
      </Section>
    );
  }
}

Readme.propTypes = {
  title: PropTypes.string,
  project: PropTypes.object,
  repoManager: PropTypes.object,
  insideFolder: PropTypes.bool,
  last: PropTypes.bool,
  t: PropTypes.func,
};
